import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-base text-app-text-600 dark:text-app-text-dark-500 font-body font-bold" }

import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Panel',
  props: {
    title: {},
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Disclosure), null, {
    default: _withCtx(() => [
      _createVNode(_unref(DisclosureButton), { class: "flex items-center w-full px-4 py-3 rounded-md bg-white dark:bg-app-gray-700 border border-app-gray-300 dark:border-transparent shadow dark:shadow-dark relative" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "leftIcon"),
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.title), 1)
        ]),
        _: 3
      }),
      _createVNode(_unref(DisclosurePanel), {
        static: _ctx.disabled,
        class: "bg-white dark:bg-app-gray-700 border border-t-0 border-app-gray-300 dark:border-transparent shadow dark:shadow-dark rounded-t-none rounded-b-md px-6 pt-4 py-3 -mt-1"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["static"])
    ]),
    _: 3
  }))
}
}

})